import service from "../services/ProductService";
import Role from "../entities/Role";
import Product from "@p1s/p1s-common-react/entities/Product";

class ProductApi {
    getVirtualProductById (virtualProductId) {
        return new Promise((resolve, reject) => {
            service.getVirtualProductById(virtualProductId)
                .then(res => resolve(getVirtualProductFromRaw(res.data)))
                .catch(err => reject(err));
        });
    }

    getAllVirtualProducts () {
        return new Promise((resolve, reject) => {
            service.getAllVirtualProducts()
                .then(res => resolve(convertJsonToVirtualProducts(res.data)))
                .catch(err => reject(err));
        });
    }


    getRolesProductById (productId) {
        return new Promise((resolve, reject) => {
            service.getRolesProductById(productId)
                .then(res => resolve(convertJsonToRoles(res.data)))
                .catch(err => reject(err));
        });
    }
}

export default new ProductApi();

function getVirtualProductFromRaw(virtualProductJson) {
    return {
        virtualProductId: virtualProductJson.Id,
        virtualProductName: virtualProductJson.Name,
        productName: virtualProductJson.DefaultProduct
    };
}

const convertJsonToVirtualProducts = (json) => {
    if (json)
        return json.map(item => new Product(item));
};

const convertJsonToRoles = (json) => {
    if (json)
        return json.map(item => new Role(item));
};
